import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const images = [
    "/assets/image/IMG-20250429-WA0004.jpg",
    "/assets/image/IMG-20250429-WA0005.jpg",
    "/assets/image/IMG-20250429-WA0007.jpg",
    "/assets/image/IMG-20250429-WA0013.jpg",
  ];

  const [showModal, setShowModal] = useState(false);
  const [currentImg, setCurrentImg] = useState(0);
  const openModal = (index) => {
    setCurrentImg(index);
    setShowModal(true);
  };
  const nextImage = () => {
    setCurrentImg((prev) => (prev + 1) % images.length);
  };
  const prevImage = () => {
    setCurrentImg((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <footer
      className="footer-wrapper footer-layout-default"
      data-bg-src="/assets/img/bg/footer-bg.png"
    >
      <div className="widget-area space-top">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-6 col-xxl-3 col-xl-3">
              <div className="widget footer-widget">
                <div className="th-widget-about">
                  <div className="about-logo">
                    <Link to="/">
                      <img
                        src="/assets/image/Logo PNG.png"
                        style={{ height: "66px", width: "170px" }}
                        alt=""
                      />
                    </Link>
                  </div>

                  <p className="about-text">
                    Al Jurf Pest Control LLC is a highly trusted and experienced
                    provider in Dubai, offering specialized pest control and
                    cleaning services for both residential and commercial
                    properties. Their services are reliable, effective, and
                    tailored to meet specific needs.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xxl-3 col-xl-3">
              <div className="widget widget_contact footer-widget">
                <h3 className="widget_title">Official Info</h3>

                <div className="th-widget-contact">
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-location-dot"></i>
                    </div>
                    <p className="info-box_text">Deira, Naif, Dubai-UAE.</p>
                  </div>
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <Link
                      to="mailto:info@aljurfpestcontrol.ae"
                      className="info-box_link"
                    >
                      info@aljurfpestcontrol.ae
                    </Link>
                  </div>
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-phone"></i>
                    </div>
                    <Link to="tel:056 118 4114" className="info-box_link">
                      056 118 4114
                    </Link>
                  </div>
                </div>

                <div className="th-social mt-4">
                  <Link
                    target="_blank"
                    to="https://www.facebook.com/share/17wS89FDNB/"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>

                  <Link to="https://www.youtube.com/">
                    <i className="fab fa-youtube"></i>
                  </Link>

                  <Link to="https://www.instagram.com/">
                    <i className="fab fa-instagram"></i>
                  </Link>

                  <Link to="https://www.tiktok.com/">
                    <i className="fab fa-tiktok"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Main Menu</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to="/about">About</Link>
                    </li>
                    <li>
                      <Link to="/service">Service</Link>
                    </li>
                    <li>
                      <Link to="/project">Project</Link>
                    </li>
                    <li>
                      <Link to="/gallery">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/blog">Blog</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xxl-3 col-xl-3">
              <div className="widget footer-widget">
                <h3 className="widget_title">Our Gallery</h3>
                <div className="widget-gallery">
                  {images.map((img, index) => (
                    <div
                      className="gallery-thumb"
                      key={index}
                      onClick={() => openModal(index)}
                    >
                      <img src={img} alt={`Gallery ${index}`} />
                      <span className="gallery-btn">
                        <i className="fab fa-instagram"></i>
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <Wrapper>
                {showModal && (
                  <div
                    className="modal-overlay"
                    onClick={() => setShowModal(false)}
                  >
                    <div
                      className="modal-content"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="close-btn"
                        onClick={() => setShowModal(false)}
                      >
                        ×
                      </button>
                      <button className="prev-btn" onClick={prevImage}>
                        ‹
                      </button>
                      <img
                        src={images[currentImg]}
                        alt="Popup"
                        className="modal-image"
                      />
                      <button className="next-btn" onClick={nextImage}>
                        ›
                      </button>
                    </div>
                  </div>
                )}
              </Wrapper>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright-wrap">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-12">
              <p className="copyright-text text-center">
                Copyright © {currentYear}{" "}
                <Link to="/">Al Jurf Pest Control LLC.</Link> Developed By{" "}
                <Link target="_blank" to="https://mahfuzztwohaa.netlify.app">
                  ToxiCoder.
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const Wrapper = styled.section`
  .widget-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .gallery-thumb {
    position: relative;
    cursor: pointer;
  }
  .gallery-thumb img {
    /* width: 100%;
    height: auto; */
    width: 128px;
    height: 100px;
  }
  .gallery-btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: white;
    background: #000000a0;
    padding: 3px;
    border-radius: 50%;
  }
  /* Modal styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  .modal-content {
    position: relative;
    max-width: 300px;
    max-height: 300px;
  }
  .modal-image {
    max-width: 300px;
    max-height: 300px;
  }
  .close-btn,
  .prev-btn,
  .next-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: #fff;
    border: none;
    font-size: 30px;
    cursor: pointer;
    padding: 5px 10px;
    z-index: 10;
  }
  .close-btn {
    top: 10px;
    right: 10px;
    transform: none;
  }
  .prev-btn {
    left: -50px;
  }
  .next-btn {
    right: -50px;
  }
  @media screen and (max-width: 425px) {
    .modal-content {
      position: relative;
      max-width: 250px;
      max-height: 250px;
    }
    .modal-image {
      max-width: 250px;
      max-height: 250px;
    }
  }
  @media screen and (max-width: 375px) {
    .modal-content {
      position: relative;
      max-width: 200px;
      max-height: 200px;
    }
    .modal-image {
      max-width: 200px;
      max-height: 200px;
    }
  }
`;

export default Footer;
